import { Drawer } from 'antd';
import React, { useContext, useMemo, useState } from 'react';
import { AppContext } from '../../../../../AppContext';
import {
  DRAWER_HEADER_ACTIONS_ID,
  DRAWER_HEADER_ACTIONS_ID_MOBILE,
  TABS,
} from '../../../../../common/constants';
import EndUsersTabsForDrawer from '../components/EndUsersTabsForDrawer';

const EndUserDrawer = () => {
  const {
    dispatch,
    state: { endUserDrawerVisible, isDesktop },
  } = useContext(AppContext);
  const [activeTabKey, setActiveTabKey] = useState(TABS?.BASIC_DETAILS?.key);

  const headerNode = useMemo(
    () => (
      <div className="header-text">
        <div className="header-title">End User Details</div>
        <span id={DRAWER_HEADER_ACTIONS_ID} />
      </div>
    ),
    [],
  );

  return (
    <Drawer
      title={headerNode}
      open={endUserDrawerVisible}
      onClose={() =>
        dispatch({ type: 'SET_END_USER_DRAWER_VISIBLE', data: false })
      }
      width={!isDesktop ? '100%' : '85%'}
      className="custom-drawer"
      getContainer={false}
    >
      <span id={DRAWER_HEADER_ACTIONS_ID_MOBILE} />
      {endUserDrawerVisible && (
        <EndUsersTabsForDrawer
          headerActionsPortalId={DRAWER_HEADER_ACTIONS_ID}
          activeTabKey={activeTabKey}
          setActiveTabKey={setActiveTabKey}
        />
      )}
    </Drawer>
  );
};

export default EndUserDrawer;
